import { render, staticRenderFns } from "./CodeBatchesView.vue?vue&type=template&id=2f9b685a"
import script from "./CodeBatchesView.vue?vue&type=script&lang=js"
export * from "./CodeBatchesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports